import { ActivityDefinition, ActivitySchedule } from '../../../model/activities';
import { tag } from "../../../model/tag";

export interface IState {
    isLoading?: boolean;
    isLoadingDetails?: boolean;
    fetchError?: boolean;
    activityDefinition?: ActivityDefinition;
    currentSchedules?: ActivitySchedule[];
    allActivities: ActivityDefinition[];
    allTags?: tag[];
    addedSchedule?:ActivitySchedule;
}

export const DefaultState = (): IState => ({
    activityDefinition: undefined,
    allActivities: []
})
